import type { Widgets } from "../../../../../api/types/dashboardsTypes";
import { isFilterWidget, isSmartViewWidget } from "../../models/isTileObjectSmartView";

export const isSupportedWidget = (widget: Widgets) => {
  return isSmartViewWidget(widget) || isFilterWidget(widget);
};
